// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TypeheadField_wrapper__2Wxzh","bordered":"TypeheadField_bordered__26z8I"};